'use strict';

import Marionette from 'backbone.marionette';

import Controller from './controller';

export default Marionette.AppRouter.extend({
  controller: Controller,
  appRoutes: {
    '': 'home',
    'home': 'home',
    'info': 'info',
    'login': 'login',
    'logout': 'logout',
    'forgot-password': 'forgotPassword',
    'register': 'register',
    'change-password(/:required)': 'changePassword',
    'approve-privacy-policy': 'approvePrivacyPolicy',

    'short-libra': 'shortLibra',
    'session/:id(/:dailysnippet)': 'startCoachSession',
    'session/:id/:question(/:dailysnippet)': 'coachQuestion',
    'short-libra-score': 'shortLibraScore',

    'snippet': 'snippet',
    'themes': 'themes',
    'theme/:id': 'themeDetail'
  }
});
